import React from 'react';
import { motion } from 'framer-motion';
export function PdfMockup() {
  return <motion.div className="relative w-full max-w-[280px] mx-auto md:max-w-[340px]" initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} data-id="element-109">
      <motion.div className="relative aspect-[3/4] rounded-r-2xl rounded-l-md shadow-book overflow-hidden" animate={{
      y: [0, -8, 0],
      rotateY: [-2, 2, -2]
    }} transition={{
      repeat: Infinity,
      duration: 6,
      ease: 'easeInOut'
    }} style={{
      transformOrigin: 'left center'
    }} data-id="element-110">
        {/* Cover image */}
        <img src="https://cdn.magicpatterns.com/uploads/6MKzAHmFSy7KwWS2gFBxCs/Bebe.png" alt="Portada de la guía Tu Bebé Sí Puede Dormir" className="absolute inset-0 w-full h-full object-cover" data-id="element-111" />

        {/* Book Binding/Spine Effect on left edge */}
        <div className="absolute left-0 top-0 bottom-0 w-3 bg-gradient-to-r from-black/15 via-black/5 to-transparent z-10 pointer-events-none" data-id="element-112" />

        {/* Subtle highlight on right edge for depth */}
        <div className="absolute right-0 top-0 bottom-0 w-[2px] bg-white/30 z-10 pointer-events-none" data-id="element-113" />

        {/* Soft inner shadow for premium feel */}
        <div className="absolute inset-0 ring-1 ring-inset ring-black/5 rounded-r-2xl rounded-l-md pointer-events-none" data-id="element-114" />
      </motion.div>

      {/* Background decorative blob */}
      <div className="absolute -inset-4 bg-rose/20 rounded-full blur-3xl -z-10 opacity-60" data-id="element-115" />
    </motion.div>;
}